import React, { useEffect } from 'react';
import classes from './AuthDrawer.module.css';

const AuthDrawer = ({ onCreateAccount, onLogin, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <>
      <div className={classes.backdrop} onClick={onClose} />
      <div className={classes.sheet}>
        <div className={classes.handle} />
        <div className={classes.actions}>
          <button className={classes.createBtn} onClick={onCreateAccount}>Create account</button>
          <button className={classes.loginBtn} onClick={onLogin}>Login</button>
        </div>
      </div>
    </>
  );
};

export default AuthDrawer;